import React, { useEffect } from 'react'

import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

import { Layout, LeftColumn, RightColumn } from './style'
import { Button, ChallengeForm, Section } from '../..'
import { useChallenge, useUser } from '../../../context'
import { removeFile } from '../../../firebase/utils/storageActions'
import Preview from '../../Cards/ChallengeCards/ChaPreviewCard'

const ChallengeFormComponent = () => {
  const navigate = useNavigate()
  const { setOnEditionMode } = useUser()
  const {
    saveNewChallenge,
    formState,
    isEditing,
    updateChallenge,
    error: chaError,
  } = useChallenge()

  const handleSaveChallenge = async () => {
    try {
      await saveNewChallenge()

      toast.success('Desafio creado')
    } catch (error) {
      toast.error(chaError)
    } finally {
      setOnEditionMode(false)
      navigate(`/desafios`)
    }
  }

  const handleUpdateChallenge = async () => {
    try {
      await updateChallenge()

      toast.success('Desafio actualizado')
    } catch (error) {
      toast.error(chaError)
    } finally {
      setOnEditionMode(false)
      navigate(`/desafios/${formState.id}`)
    }
  }

  const handleCancelChallenge = async () => {
    setOnEditionMode(false)
    navigate(`/desafios`)

    if (isEditing || !formState.image) return
    try {
      await removeFile(formState.image)
    } catch (error) {
    } finally {
      setOnEditionMode(false)
      navigate(`/desafios`)
    }
  }

  useEffect(() => {
    setOnEditionMode(true)
  }, [])

  return (
    <Section
      title={`${isEditing ? 'Editar' : 'Crear nuevo'} desafío`}
      subtitle="Configura los detalles del reto"
      childrenClass="full-space-section"
      style={{ overflowY: 'scroll', maxHeight: 'calc(100vh - 290px)' }}
      ctaSection={{
        alignItems: 'center',
        cta: (
          <>
            <Button
              fontSize={13}
              fontWeight={600}
              onClick={handleCancelChallenge}
              label="Cancelar"
            />
            <Button
              fontSize={13}
              fontWeight={600}
              onClick={isEditing ? handleUpdateChallenge : handleSaveChallenge}
              label={isEditing ? 'Guardar cambios' : 'Guardar desafío'}
              className="light-blue"
            />
          </>
        ),
      }}
    >
      <Layout>
        <RightColumn>
          <ChallengeForm />
        </RightColumn>
        <LeftColumn>
          <Preview />
        </LeftColumn>
      </Layout>
    </Section>
  )
}

export default ChallengeFormComponent
